import { FileReference } from "../OiReport";

export enum AnalysisOrderPriority {
  LOW = "1 - Low",
  NORMAL = "2 - Normal",
  IMPORTANT = "3 - Important",
  HIGH = "4 - High",
  URGENT = "5 - Urgent",
}

export interface AnalysisOrderSample {
  sampleId: string;
  linkedPowderOrderId: string;
  coPercentage: number | null;
}

export interface SelectedAnalysesData {
  selectedAnalyses: string[];
}

export interface PreparationRoutingItem {
  selectedOptions: string[];
  enabled?: boolean;
  details?: string;
}

export interface PreparationAndRoutingData {
  comment: string;
  selectedPreparationMethods: string[];
  noPreparationRequired: boolean;
  routes: Record<string, PreparationRoutingItem>;
}

export class AnalysisOrder {
  author: string = "";
  requestedBy: string = "";
  orderId: string = "";
  linkedPowderOrder: string = "";
  linkedPowderOrderLabel: string = "";
  requesterDepartment: string = "";
  orderDate: string = "";
  requestedDeliveryDate: string = "";
  priority: AnalysisOrderPriority = AnalysisOrderPriority.NORMAL;
  reasonForHigherPriority: string = "";
  returnMaterial: boolean = false;
  samples: AnalysisOrderSample[] = [];
  selectedAnalysesJsonData: SelectedAnalysesData = {
    selectedAnalyses: [],
  };
  preparationAndRoutingJsonData: PreparationAndRoutingData = {
    comment: "",
    selectedPreparationMethods: [],
    noPreparationRequired: false,
    routes: {},
  };
  comment: string = "";
  tags: string[] = [];
  taggedStaff: string[] = [];
  uploadedFiles: FileReference[] = [];
  isDraft: boolean = true;
  isSubmittedForReview: boolean = false;
  reviewPassed: boolean | null = null;
}